<template>
  <div class="container">
    <div class="header">
      <h1 align="center" style="font-size: xx-large">数据下载问卷调查</h1>
      <h3 style="font-size: 20px; width: 700px; margin-left: auto;margin-right: auto ;margin-bottom: auto ">
        免责声明：TALL不对您使用下载数据开展研究的性质和结果负责。<br/>
        TALL is not responsible for the nature or outcomes of research
        carried out with the data you are downloading.<br/>

        TALL希望研究人员分享他们使用下载数据的经验和感受，使这个资源能提供更多的信息。
        TALL团队能够通过邮件联系您了解您是否使用和如何使用下载的数据，如果您愿意收到我们的联系邮件，
        请提供您的邮箱：<br/>
        TALL will be an even more informative resource if researchers
        share their experience of using data that they have downloaded.
        The TALL team would like to contact you by email to seek brief
        feedback on whether, and if so how you have used the data.
        If you are happy to be contacted, please leave your email below:<br/>



      </h3>
    </div>

    <div class="content" style="margin-top: 150px">
      <div class="left"></div>
      <div class="center">
        <div>



          <el-form :model="content" ref="numberValidateForm">
            <div>
              <!--email填写-->
              <div  class="el-row">
                <p style="font-size: 24px; justify-content: center">  * Email：
                </p>
                <el-form-item prop="email"
                              :rules="[{ required: true, message: '请填写Email'},
                              {type: 'email', message: '请输入正确的邮箱', trigger: ['blur', 'change'] }]">
                  <el-input v-model="content.email" placeholder="请填写邮箱" style="width: 350px
                  ;margin-top:10px ; margin-left: 10px"></el-input>
                </el-form-item>
              </div>
              <h3 style="font-size: 20px; width: 700px; margin-left: auto;margin-right: auto ;margin-bottom: auto ">
                请提供一些关于您个人的简要信息，这些信息仅用于帮助我们了解TALL使用者的情况。<br/>
                Please provide some brief details about yourself.
                These will only be used to help us evaluate who is using TALL.</h3>


              <!-- 身份选择-->
              <div class="el-row" >
                <p style="font-size: 24px">  * 个人情况 （请选择所有符合的选项）： （必填）<br/>
                  About you - (please tick all that apply): <font color="red">(Obligatory)</font>
                </p>
                <el-form-item size="large"
                              prop="identity"
                              :rules="[{ required: true, message: '请选择身份', trigger: 'blur' },]">
                  <el-cascader
                      :options="options1"
                      :show-all-levels="false"
                      @change="handleChange"
                      placeholder="请选择身份"
                      v-model="content.identity"
                      style="width: 350px"
                  >
                  </el-cascader>
                </el-form-item>
              </div>
              <!-- 国家选择-->
              <div  class="el-row">
                <p style="font-size: 24px; justify-content: center">  * 国家/地区： （必填）<br/>
                  Country/region:  <font color="red">(Obligatory)</font>
                </p>
                <el-form-item prop="country"
                              :rules="[{ required: true, message: '请填写国家'},
                              {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }]">
                  <el-input v-model="content.country" placeholder="请填写国家" style="width: 350px
                  ;margin-top: 35px; margin-left: 10px"></el-input>
                </el-form-item>
              </div>
              <!-- 学校选择-->
              <div  class="el-row">
                <p style="font-size: 24px">  * 学校：（必填）<br/>
                  Institution:  <font color="red">(Obligatory)</font>
                </p>

                <el-form-item prop="school"
                              :rules="[{ required: true, message: '请填写学校'},
                              {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }]">
                  <el-input v-model="content.school" placeholder="请填写学校" style="width: 350px
                  ;margin-top: 35px; margin-left: 10px"></el-input>
                </el-form-item>

              </div>
            </div>
            <div class="yesbutton">
              <el-button type="primary" @click="submitForm('numberValidateForm')">提交<br/>
                Submit
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="right"></div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import GLOBAL from "../../plugins/global_variable";

export default {
  name: "dataquestionnaire",
  data() {
    return {
      user: {
        email: '',
        pwd:'',
      },
      options1: [{
        value: '0',
        label: '学生 Student ',
        children: [
          {
            value: '01',
            label: '本科生 Undergraduate'
          },
          {
            value: '02',
            label: '硕士生 Masters',
          },
          {
            value: '03',
            label: '博士生 PhD',
          },
          {
            value: '04',
            label: '其它 Other',
          },
        ]
      }
        , {
          value: '1',
          label: '语言教师（任何层次）Language teacher/instructor (any level)'
        }
        ,{
          value: '2',
          label: '教师教育者  Teacher educator'
        }
        ,{
          value: '3',
          label: '大学学术人员 University academic',
          children: [
            {
              value: '31',
              label: ' 初级 Early career'
            },
            {
              value: '32',
              label: '中级 Mid-career',
            },
            {
              value: '33',
              label: ' 高级 Established scholar',
            }
          ]
        }],

      content: {
        email:'',
        identity: '',
        country:'',
        school:'',

      },

    }
  },

  methods: {
    handleChange(value) {
      console.log(value);
      var n = value.length
      console.log(n)
      var identity_key = value[n-1]
      console.log(identity_key)
      this.content.identity = identity_key

    },

    submitForm(formName) {

      console.log(this.content)
      var _this = this;
      //各个问卷调查格式都正确
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.content);

          this.$confirm('确定问卷填写无误? Please make sure that the questions are answered', 'Notice', {
            confirmButtonText: 'confirm',
            cancelButtonText: 'cancel',
            type: 'warning'
          }).then(() => {
            //赋值给全局变量
            console.log('ns')
            GLOBAL.content=this.content;
            console.log(GLOBAL.content)
            axios.post('download_per/save', GLOBAL.content).then(
                function (resp) {
                  if (resp.data != null) {
                    var _this = this;
                    _this.$message({
                      message: 'Fill out the questionnaire successfully and get the download information! Due to the large amount of data, please wait patiently, it is estimated to be about 1 minute',
                      type: 'success',
                    });
                  }
                });
            let fileName = GLOBAL.dataname+".zip"
            var dataname = GLOBAL.dataname
            axios({url:"/openData/downloadData?filename="+dataname,responseType: 'blob'}).then((response) => {
              const content = response.data
              const blob = new Blob([content], {type: "zip"})
              if ('download' in document.createElement('a')) { // 非IE下载
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href) // 释放URL 对象
                document.body.removeChild(elink)
                this.generate = !this.generate
              } else { // IE10+下载
                navigator.msSaveBlob(blob, fileName)
              }
            });


            //
            // if (GLOBAL.cur==1){
            //   let fileName = "tall_edu"+GLOBAL.com+".zip"
            //
            //   axios({
            //     url: "/openData/downloadByEdu",
            //     params:{'edu':2},
            //     responseType: 'blob'
            //   }).then((response) => {
            //     const content = response.data
            //     const blob = new Blob([content], {type: "zip"})
            //     if ('download' in document.createElement('a')) { // 非IE下载
            //       const elink = document.createElement('a')
            //       elink.download = fileName
            //       elink.style.display = 'none'
            //       elink.href = URL.createObjectURL(blob)
            //       document.body.appendChild(elink)
            //       elink.click()
            //       URL.revokeObjectURL(elink.href) // 释放URL 对象
            //       document.body.removeChild(elink)
            //       this.generate = !this.generate
            //     } else { // IE10+下载
            //       navigator.msSaveBlob(blob, fileName)
            //     }
            //   });
            //
            //
            //
            //
            // }
            // else if (GLOBAL.cur==2){
            //   let fileName = "tall_country"+GLOBAL.com+".zip"
            //   axios({
            //     url: "/openData/downloadByCountry"+GLOBAL.com,
            //     responseType: 'blob'
            //   }).then((response) => {
            //     const content = response.data
            //     const blob = new Blob([content], {type: "zip"})
            //     if ('download' in document.createElement('a')) { // 非IE下载
            //       const elink = document.createElement('a')
            //       elink.download = fileName
            //       elink.style.display = 'none'
            //       elink.href = URL.createObjectURL(blob)
            //       document.body.appendChild(elink)
            //       elink.click()
            //       URL.revokeObjectURL(elink.href) // 释放URL 对象
            //       document.body.removeChild(elink)
            //       this.generate = !this.generate
            //     } else { // IE10+下载
            //       navigator.msSaveBlob(blob, fileName)
            //     }
            //   });
            //
            //
            // }
            //
            // else if (GLOBAL.cur==3){
            //   let fileName = "tall_major"+GLOBAL.com+".zip"
            //   axios({
            //     url: "/openData/downloadByMajor?major="+GLOBAL.com,
            //     responseType: 'blob'
            //   }).then((response) => {
            //     const content = response.data
            //     const blob = new Blob([content], {type: "zip"})
            //     if ('download' in document.createElement('a')) { // 非IE下载
            //       const elink = document.createElement('a')
            //       elink.download = fileName
            //       elink.style.display = 'none'
            //       elink.href = URL.createObjectURL(blob)
            //       document.body.appendChild(elink)
            //       elink.click()
            //       URL.revokeObjectURL(elink.href) // 释放URL 对象
            //       document.body.removeChild(elink)
            //       this.generate = !this.generate
            //     } else { // IE10+下载
            //       navigator.msSaveBlob(blob, fileName)
            //     }
            //   });
            //
            //
            // }
            //
            // else if (GLOBAL.cur==4){
            //   let fileName = "tall_cet.zip"
            //   axios({
            //     url: "/openData/downloadByCetGrade",
            //     responseType: 'blob'
            //   }).then((response) => {
            //     const content = response.data
            //     const blob = new Blob([content], {type: "zip"})
            //     if ('download' in document.createElement('a')) { // 非IE下载
            //       const elink = document.createElement('a')
            //       elink.download = fileName
            //       elink.style.display = 'none'
            //       elink.href = URL.createObjectURL(blob)
            //       document.body.appendChild(elink)
            //       elink.click()
            //       URL.revokeObjectURL(elink.href) // 释放URL 对象
            //       document.body.removeChild(elink)
            //       this.generate = !this.generate
            //     } else { // IE10+下载
            //       navigator.msSaveBlob(blob, fileName)
            //     }
            //   });
            //
            //
            // }
            //
            // else if (GLOBAL.cur==5){
            //   let fileName = "tall_sex"+GLOBAL.com+".zip"
            //   axios({
            //     url: "/openData/downloadBySex?sex="+GLOBAL.com,
            //     responseType: 'blob'
            //   }).then((response) => {
            //     const content = response.data
            //     const blob = new Blob([content], {type: "zip"})
            //     if ('download' in document.createElement('a')) { // 非IE下载
            //       const elink = document.createElement('a')
            //       elink.download = fileName
            //       elink.style.display = 'none'
            //       elink.href = URL.createObjectURL(blob)
            //       document.body.appendChild(elink)
            //       elink.click()
            //       URL.revokeObjectURL(elink.href) // 释放URL 对象
            //       document.body.removeChild(elink)
            //       this.generate = !this.generate
            //     } else { // IE10+下载
            //       navigator.msSaveBlob(blob, fileName)
            //     }
            //   });
            //
            //
            // }
            //
            // else if (GLOBAL.cur==6){
            //   let fileName = "tall_all.zip"
            //   axios({
            //     url: "/openData/downloadAll",
            //     responseType: 'blob'
            //   }).then((response) => {
            //     const content = response.data
            //     const blob = new Blob([content], {type: "zip"})
            //     if ('download' in document.createElement('a')) { // 非IE下载
            //       const elink = document.createElement('a')
            //       elink.download = fileName
            //       elink.style.display = 'none'
            //       elink.href = URL.createObjectURL(blob)
            //       document.body.appendChild(elink)
            //       elink.click()
            //       URL.revokeObjectURL(elink.href) // 释放URL 对象
            //       document.body.removeChild(elink)
            //       this.generate = !this.generate
            //     } else { // IE10+下载
            //       navigator.msSaveBlob(blob, fileName)
            //     }
            //   });
            //
            //
            // }
            // axios.post('', GLOBAL.content).then(
            //     function (resp) {
            //       console.log('nn')
            //       if (resp.data != null) {
            //         console('su')
            //         _this.$message({
            //           message: '问卷填写成功，获得下载资格！',
            //           type: 'success',
            //
            //         });
            //
            //
            //         _this.$router.push('/dataindex');
            //
            //
            //       }
            //
            //     });

          }).catch(() => {
            _this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }
      });
    },
  },
  created() {//生命周期函数
    document.body.style.backgroundColor="#DCDCDC";
  },
  mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });

  }
}
</script>


<style scoped>
.row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom:20px
}
.el-row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  margin-bottom:20px
}
.yesbutton{
  display: flex;
  justify-content: center;
  margin-bottom:80px
}
.container{
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.header{
  display: flex;
  flex-direction: column;
  height: 40vh;
}
.footer{
  height: 75px;
}
.content{
  display: flex;
  flex-direction: row;
  flex: 1;
}
.el-row{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom:80px
}
.left,.right{
  width:200px;
}
.center{
  flex: 1;
}
.normal{
  font-size:22px;
  font-weight: normal;
}
/*.el-form-item>>>{*/
/*  font-size:22px;*/
/*}*/

.el-form-item >>> label{
  font-size: 22px;
}

.el-select >>>{
  font-size: 22px;
}








</style>